export default __webpack_public_path__ + "static/media/Screenshot (1148).656273d9.png";